var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6934 76.482C20.2063 76.482 14.436 72.3285 12.3407 66.1451L12.1989 65.6791C11.7048 64.0416 11.4978 62.6646 11.4978 61.2868V33.6594L1.66737 66.473C0.403045 71.2994 3.28413 76.3031 8.11809 77.6364L70.7771 94.4164C71.5591 94.619 72.3411 94.7162 73.1113 94.7162C77.1469 94.7162 80.8345 92.0377 81.8681 88.0905L85.5186 76.482H26.6934Z",
    fill: "#F1F5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6302 14.6159V61.3137C98.6302 66.3489 94.5387 70.4501 89.5157 70.4501H26.727C26.322 70.4501 25.917 70.4092 25.5521 70.3683C21.299 69.8412 17.9775 66.3489 17.6533 62.0446C17.6125 61.8007 17.6125 61.5568 17.6125 61.3137V14.6159C17.6125 9.58077 21.704 5.47949 26.727 5.47949H89.5157C94.5387 5.47949 98.6302 9.58077 98.6302 14.6159Z",
    fill: "#F1F5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9883 25.7339C45.9883 30.2187 42.3523 33.8552 37.8673 33.8552C33.3815 33.8552 29.7456 30.2187 29.7456 25.7339C29.7456 21.249 33.3815 17.6125 37.8673 17.6125C42.3523 17.6125 45.9883 21.249 45.9883 25.7339Z",
    fill: "#FFC107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6301 49.8773V61.3023C98.6301 66.3437 94.5325 70.45 89.5017 70.45H26.617C26.2114 70.45 25.8058 70.4091 25.4403 70.3681L67.2283 28.4924C69.9873 25.7275 74.5307 25.7275 77.2897 28.4924L98.6301 49.8773Z",
    fill: "#388E3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5597 70.4502H26.6915C26.2862 70.4502 25.881 70.4093 25.5159 70.3685C21.2603 69.8416 17.9369 66.3515 17.6125 62.05L36.8651 42.7738C39.6215 40.0149 44.1606 40.0149 46.917 42.7738L74.5597 70.4502Z",
    fill: "#4CAF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.94b062a729f95dd71889ef79b7ea9a9b.svg";
export { ForwardRef as ReactComponent };